import cx from "classnames"
import { camelize } from "../../utils"
import type { IconColorsType } from "../"
export type IconProps = {
  color?: IconColorsType
  size?: 16 | 20 | 24 | 32
  contained?: boolean
  className?: string
}
const iconSource = "starHalfFilled"
const StarHalfFilledIcon = ({
  color,
  size = 24,
  contained = false,
  className,
}: IconProps) => {
  const computedClassName = cx(
    className,
    `cobalt-Icon cobalt-Icon--${iconSource}`,
    {
      [`c-fill-${camelize(color || "")}`]: color,
      "cobalt-Icon--size16": size === 16,
      "cobalt-Icon--size20": size === 20,
      "cobalt-Icon--size32": size === 32,
      "cobalt-Icon--contained": contained,
    },
  )
  return (
    <span className={computedClassName}>
      {
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24">
          <title>{iconSource}</title>
          <path d="M12 2.445V18.375L6.733 21.145Q6.629 21.197 6.524 21.218T6.316 21.229Q6.266 21.224 6.216 21.212 6.116 21.188 6.027 21.141C5.852 21.045 5.715 20.88 5.66 20.679Q5.632 20.579 5.633 20.467 5.635 20.41 5.644 20.353L6.65 14.488 2.389 10.335C2.055 10.009 2.11 9.502 2.419 9.23Q2.533 9.13 2.693 9.08 2.748 9.063 2.804 9.055L8.695 8.199 11.327 2.862C11.465 2.584 11.733 2.445 12 2.445" />
        </svg>
      }
    </span>
  )
}
export default StarHalfFilledIcon
